import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Uploads from '../../../components/upload/Uploads';
import AlbumGrid from '../../../components/AlbumGrid';
import Pagination from '../../../components/Pagination';
import Avatar from '../../../components/Avatar'
import {LoadingBar, PageLoader} from '../../../components/Loader';
import {fetchUserAlbums, resetUserAlbums} from "../../../../creators/user.albums";
import AlbumInformations from "../../../components/AlbumInformations";
import {Button} from "../../../components/Button";
import {bindActionCreators} from "redux";
import Modal from "../../../components/Modal";
import {Can} from "../../../../ability-context";
import createLink from "../../../../libs/createLink";
import {config} from "../../../../config";
import {canonical} from "../../../../libs/helper";
import Helmet from "react-helmet";
import CtaCannot from "../../../components/CtaCannot";

class ProfilAlbum extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 5,
            page: 1,
            sort: "-createdAt"
        };
        this.state = {
            toggle: false,
            toggleCreateAlbum: false,
            currentPage: this.props.match && (this.props.match.params.page || 1),
            filter: this.filter,
        };
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleClosePopup = this.handleClosePopup.bind(this);
        this.handleRender = this.handleRender.bind(this);
        this.getUserAlbums = this.getUserAlbums.bind(this);

        this.getUserAlbums(this.props.user._id, this.state.filter);
    }

    componentWillUnmount() {
        this.props.resetUserAlbums();
        this.setState({filter: this.filter});
    }

    getUserAlbums(userId, filter) {
        this.props.fetchUserAlbums(userId, filter);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user._id !== this.props.user._id) {
            let newFilter = {...this.state.filter};
            this.getUserAlbums(this.props.user._id, newFilter);
        }
    }

    handleChangePage(page, link) {
        let newFilter = {...this.state.filter, page};
        this.getUserAlbums(this.props.user._id, newFilter);
        this.setState({filter: newFilter, currentPage: page});

        if (page === 1) {
            this.props.history.push(link);
        } else {
            this.props.history.push(link + '/' + page);
        }
        window.scrollTo(0, 0);
    }

    handleClosePopup() {
        /*if(this.props.isMe){
            this.setState({toggle: false}, () => this.getUserAlbums(this.props.user._id, this.state.filter));
        }
        else{
            this.setState({toggle: false});
        }*/
        this.setState({toggle: false});
    }

    handleRender() {
        this.handleClosePopup();
    }


    render() {
        let totalPage = !this.props.albumsLoading && this.props.albums ? Math.ceil(this.props.albumsTotal / this.state.filter.limit) : 0;
        let linkPagination = this.props.currentPage && createLink('userAlbums', this.props.user);
        if (this.props.isMe) {
            linkPagination = createLink('userMeAlbums', this.props.user);
        }
        let currentPage = parseInt(this.state.filter.page);
        let owner = this.props.albums && this.props.albums.length >= 1 ? this.props.albums.owner : {};
        return !this.props.albumsInitialized ? (
            <div className="main-wrapper album-page card big">
                <PageLoader/>
            </div>
        ) : (
            <div className="main-wrapper album-page card big">
                {this.props.albums && this.props.albums.length >= 1 ? (
                    <Fragment>
                        <Helmet>
                            <title>{config.preTitle}Albums de {this.props.user.username}{config.postTitle}</title>
                            {currentPage === 2 && (<link rel="prev" href={canonical(linkPagination, "", "albums")} />)}
                            {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${linkPagination}/${(currentPage - 1)}`, "", "albums")}`} />)}
                            <link rel="canonical" href={currentPage >1 ? `${canonical(`${linkPagination}/${currentPage}`, "", "albums")}` : canonical(linkPagination, "", "albums")} />
                            {currentPage < totalPage && (<link rel="next" href={`${canonical(`${linkPagination}/${(currentPage + 1)}`, "", "albums")}`} />)}
                        </Helmet>
                        {!this.props.currentPage && (
                            <div className="topline-album">
                                {owner && owner._id ? (
                                    <Link to={createLink('userProfile', this.props.user)}>
                                        <Avatar avatar={owner.profile.avatar} gender={owner.profile.gender} alt=""/>
                                    </Link>
                                ) : (
                                    <Avatar gender="guest" alt=""/>
                                )}
                                <div className="album-title"> Album(s) de&nbsp;
                                    <Link
                                        to={createLink('userProfile', this.props.user)}>
                                        {this.props.user.username}
                                    </Link>
                                </div>
                            </div>
                        )}
                        {this.props.isMe && (
                            <div className="album-page-btn-group row justify-end align-center full">
                                <Can action="create" subject="Album" passThrough>
                                    {can => {
                                        return can ? (
                                            <Fragment>
                                                <Button className="upload-media-btn"
                                                        size={"small"}
                                                        btnStyle={"primary-reverse"}
                                                        onClick={() => this.setState({toggleCreateAlbum: true})}
                                                        content={"Créer un album"}/>
                                                <Modal toggle={this.state.toggleCreateAlbum}
                                                       handleClose={() => this.setState({toggleCreateAlbum: false})}>
                                                    <AlbumInformations createAlbum={true}
                                                                       userId={this.props.user._id}
                                                                       handleRender={this.handleRender}
                                                                       handleClose={() => this.setState({toggleCreateAlbum: false})}/>
                                                </Modal>
                                            </Fragment>
                                        ) : (
                                            <CtaCannot action={"createAlbum"} isModal={true} button={{content : "Créer un album", btnStyle : "primary-reverse", size : "small", className:"upload-media-btn"}} />
                                        )}}
                                </Can>

                                <Can action="upload" subject="Media" passThrough>
                                    {can => {
                                        return can ? (
                                            <Fragment>
                                                <Button className="upload-media-btn"
                                                        size={"small"}
                                                        btnStyle={"primary-reverse"}
                                                        onClick={() => this.setState({toggle: true})}
                                                        icon={"arrow-up"}
                                                        content={"Envoyer une photo / vidéo"}/>
                                                <Modal toggle={this.state.toggle} handleClose={() => this.handleClosePopup()}>
                                                    <Uploads handleClose={() => this.handleClosePopup()} callback={this.handleRender}/>
                                                </Modal>
                                            </Fragment>
                                        ) : (
                                            <CtaCannot action={"upload"} isModal={true} button={{content : "Envoyer une photo / vidéo", btnStyle : "primary-reverse", size : "small", className:"upload-media-btn", icon : "arrow-up"}} />
                                        )}}
                                </Can>

                            </div>
                        )}
                        {this.props.albumsLoading && <LoadingBar/> }
                        <div className={"column"}>
                            {this.props.albums.map((item) =>
                                <AlbumGrid type={"album-page"}
                                           handleRender={() => this.handleRender()}
                                           {...this.props}
                                           {...item}
                                           key={item._id}/>
                            )}
                            <div className="btn-group">
                                {totalPage > 1 && (
                                    <Pagination
                                        currentPage={this.state.currentPage}
                                        pagesCount={totalPage}
                                        handleChangePage={this.handleChangePage}
                                        link={linkPagination}
                                    />
                                )}
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        {this.props.isMe && this.props.albums.length === 0 && (
                            <Fragment>
                                <div className="no-album">Vous n'avez pas encore créé d'album, mettez en ligne du
                                    contenu dès maintenant !
                                </div>
                                <Can action="upload" subject="Media" passThrough>
                                    {can => {
                                        return can ? (
                                            <Fragment>
                                                <Button className="album-big"
                                                        size={"small"}
                                                        onClick={() => this.setState({toggle: true})}
                                                        icon={"arrow-up"}
                                                        content={"Envoyer une photo/vidéo"}/>
                                                <Modal toggle={this.state.toggle} handleClose={() => this.handleClosePopup()}>
                                                    <Uploads handleClose={() => this.handleClosePopup()} callback={this.handleRender}/>
                                                </Modal>
                                            </Fragment>
                                        ) : (
                                            <CtaCannot action={"upload"} isModal={true} button={{content : "Envoyer une photo / vidéo", btnStyle : "primary-reverse", size : "small", className:"album-big", icon : "arrow-up"}} />
                                        )}}
                                </Can>

                            </Fragment>
                        )}
                        {!this.props.isMe && this.props.albumsTotal === 0 && (
                            <div className="no-content big">Cet utilisateur n'a pas encore d'album</div>
                        )}
                    </Fragment>
                )}
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        albums: state.userAlbums.data,
        albumsLoading: state.userAlbums.loading,
        albumsInitialized: state.userAlbums.initialized,
        albumsTotal: state.userAlbums.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserAlbums,
    resetUserAlbums
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ProfilAlbum);
